const toggleFormControl = () => {
 const DATA_GROUP = `toggle-group`;
 const DATA_TOGGLE = `toggle`;
 const DATA_TOGGLE_DISABLED = `toggle-disabled`;
 const DATA_RESET_VALUE = `reset-value`;

 const SELECTOR_CHECK = `.check[data-${DATA_TOGGLE}]`;
 const SELECTOR_SELECT = `.select:has([data-${DATA_TOGGLE}])`;

 const CLASS_ACTIVE = `active`;

 const updateState = (target) => {
 const isSelect = target.matches(`select`);
 const isCheckbox = target.matches(`input[type="checkbox"]`);

 const targetGroup = target.closest(`[data-${DATA_GROUP}]`);

 if (!targetGroup) return;

 const groupData = targetGroup.getAttribute(`data-${DATA_GROUP}`);
 const toggleData = isSelect
 ? target.selectedOptions[0].getAttribute(`data-${DATA_TOGGLE}`)
 : target.getAttribute(`data-${DATA_TOGGLE}`);

 if (!groupData) return;

 const groupSelector = `[data-${DATA_GROUP}~="${groupData}"]`;
 const toggleSelector = `[data-${DATA_TOGGLE}~="${toggleData}"]`;

 const targetGroups = document.querySelectorAll(groupSelector);
 const targetElements = document.querySelectorAll(
 `${groupSelector}${toggleSelector}`,
 );

 // Disabled elements
 if (targetGroup.matches(`[data-${DATA_TOGGLE_DISABLED}]`)) {
 const isResetValue = targetGroup.matches(`[data-${DATA_RESET_VALUE}]`);

 targetGroups.forEach((el) => el.classList.add(CLASS_ACTIVE));

 if (isCheckbox) {
 targetElements.forEach((el) => {
 el.disabled = !target.checked;
 isResetValue && (el.value = ``);
 });
 } else {
 targetGroups.forEach((el) => {
 el.disabled = true;
 isResetValue && (el.value = ``);
 });
 targetElements.forEach((el) => (el.disabled = false));
 }
 }

 // Active elements
 else {
 if (isCheckbox) {
 targetElements.forEach((el) =>
 el.classList.toggle(CLASS_ACTIVE, target.checked),
 );
 } else {
 targetGroups.forEach((el) => el.classList.remove(CLASS_ACTIVE));
 targetElements.forEach((el) => el.classList.add(CLASS_ACTIVE));
 }
 }
 };

 const handleInput = ({ target }) => {
 if (!target.closest(SELECTOR_CHECK) && !target.closest(SELECTOR_SELECT))
 return;

 updateState(target);
 };

 const applyToggleState = () => {
 document
 .querySelectorAll(`${SELECTOR_CHECK}:checked, ${SELECTOR_SELECT}`)
 .forEach((target) => {
 updateState(target);
 });
 };

 const initialize = () => {
 applyToggleState();

 document.body.addEventListener(`input`, handleInput);
 };

 initialize();

 toggleFormControl.update = applyToggleState;

 toggleFormControl.cleanup = () => {
 document.body.removeEventListener(`input`, handleInput);
 };
};

export default toggleFormControl;
